module.exports = __webpack_public_path__ + "static/img/ES.44ece645.png";